export const venueUserConstants = {
    LOAD_STARTED: 'LOAD_STARTED',
    LOAD_SUCCESS: 'LOAD_SUCCESS',
    LOAD_FAIL: 'LOAD_FAIL',
    ADD: 'ADD',    
    DELETE: 'DELETE',
    
}

export default venueUserConstants;